export const GetRunTime = "GetRunTime";
export const GetRunTimeSuccess = "GetRunTimeSuccess";
export const GetRunTimeError = "GetRunTimeError";
